<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh">百年历史</router-link> >
      {{ current.title }}
    </div>

    <div class="container-width">
      <ARTICLE :current="current"></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../service/sjwh";
import BANNER from "../../components/banner/sjwh";

export default {
  name: "SJWHARTICLEHUNDRED",
  data() {
    return {
      navigationData: [
        {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        // {
        //   name: "盛京医讯",
        //   path: "/sjwh/zhoukan",
        //   width: "33%",
        // },
        // {
        //   name: "盛京TV",
        //   path: "/sjwh/tv",
        // },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh",
      current: {
        title: "",
        description: "",
        releaseDate: "",
        views: "",
        origin: "",
      },

      showBeforeAfter: false, //是否显示上一篇 下一篇
      showorigin: false, //是否显示来源 发布时间 点击次数
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {};
      // 大道精深 大道精诚
      service.getMainRoad(parmes, (res) => {
        this.current = { ...res };
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
</style>
